import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';

import { SummaryIcon, CaretIcon } from './icons';
import { Widget, WHead, WIco, WTitle, Chip, Caret, WBody, Bar, Stats, Stat, Row, Grow, Wait, Empty } from './widgets-dock.styled';

const fill = (freePct) => {
  if (freePct <= 0.08) return '#e0555f';
  if (freePct <= 0.25) return '#e0932f';
  return '#47b972';
};

export const SummaryWidget = ({ open, onToggle }) => {
  const { t } = useTranslation();
  const boards = useSelector((store) => store.boards.boards, shallowEqual);

  const cfg = (window.config.objects && window.config.objects.boards) || [];

  let maximum = 0;
  let free = 0;
  let onetime = 0;
  let freeOne = 0;
  let regular = 0;
  let freeReg = 0;
  let hasData = false;

  cfg.forEach((b) => {
    const z = boards ? boards[b.zoneId] : null;
    if (!z) {
      return;
    }
    hasData = true;
    const zmax = z.maximum || 0;
    maximum += zmax;
    free += typeof z.free === 'number' ? z.free : Math.max(0, zmax - (z.current || 0));
    onetime += z.onetime || 0;
    freeOne += typeof z.free_onetime === 'number' ? z.free_onetime : 0;
    regular += z.regular || 0;
    freeReg += typeof z.free_regular === 'number' ? z.free_regular : 0;
  });

  const freePct = maximum ? free / maximum : 0;
  const occPct = maximum ? Math.min(100, Math.round((1 - freePct) * 100)) : 0;

  return (
    <Widget>
      <WHead type="button" className={open ? '' : 'closed'} onClick={onToggle}>
        <WIco>
          <SummaryIcon />
        </WIco>
        <WTitle>{t('dock.Сводка по объекту')}</WTitle>
        {hasData && <Chip className="ghost">{free}</Chip>}
        <Caret className={open ? 'open' : ''}>
          <CaretIcon />
        </Caret>
      </WHead>
      {open && (
        <WBody>
          {!hasData && <Empty>{t('dock.Нет данных по объекту')}</Empty>}
          {hasData && (
            <>
              <Stats>
                <Stat className="ok">
                  <b>{free}</b>
                  <span>{t('dock.свободно из')} {maximum}</span>
                </Stat>
              </Stats>
              <Bar>
                <i style={{ width: occPct + '%', background: fill(freePct) }} />
              </Bar>
              <Row>
                <Grow>{t('dock.Разовые')}</Grow>
                <Wait>
                  {freeOne}/{onetime}
                </Wait>
              </Row>
              <Row>
                <Grow>{t('dock.Постоянные')}</Grow>
                <Wait>
                  {freeReg}/{regular}
                </Wait>
              </Row>
            </>
          )}
        </WBody>
      )}
    </Widget>
  );
};
